import { render, staticRenderFns } from "./OccupationSkillsSelector.vue?vue&type=template&id=3b408c88&scoped=true"
import script from "./OccupationSkillsSelector.vue?vue&type=script&lang=js"
export * from "./OccupationSkillsSelector.vue?vue&type=script&lang=js"
import style0 from "./OccupationSkillsSelector.vue?vue&type=style&index=0&id=3b408c88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b408c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b408c88')) {
      api.createRecord('3b408c88', component.options)
    } else {
      api.reload('3b408c88', component.options)
    }
    module.hot.accept("./OccupationSkillsSelector.vue?vue&type=template&id=3b408c88&scoped=true", function () {
      api.rerender('3b408c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/OccupationSkillsSelector.vue"
export default component.exports